import { createRoute, redirect } from '@tanstack/react-router'

import { rootRoute as productRootRoute } from '@/product/root'
import { canReadFeedback } from '@/product/feedback/access'

export const rootRoute = createRoute({
    getParentRoute: () => productRootRoute,
    path: '/feedback',
    beforeLoad: async () => {
        if (!canReadFeedback()) {
            throw redirect({ to: '/' })
        }
    },
})
